import React from "react";
import { getTopic } from "../../app/api";
import { ITopic } from "../../app/types";
import { Container } from "semantic-ui-react";
import Question from "../../components/question/Question";
import { useParams } from "react-router-dom";

const TopicPage = () => {
  const { topicId } = useParams();
  const [topic, setTopic] = React.useState<ITopic | null>(null);

  React.useEffect(() => {
    getTopic(Number(topicId)).then((topic) => setTopic(topic));
  }, [topicId]);

  if (!topic) {
    return <></>;
  }

  return (
    <Container text>
      <h1>
        Тема {topic.id}: {topic.title}
      </h1>
      <span>{topic.questions?.length} вопросов</span>

      <>
        {topic.questions?.map((question) => (
          <Question question={question} key={question.id} />
        ))}
      </>
    </Container>
  );
};

export default TopicPage;
